import Role, { ROLES_PERMISSIONS_MAPPING } from "./Role";

export const PERMISSIONS_EMPLOYEES_CONST = [
  // Employees Resource
  'create.employees',
  'read.employees',
  'update.employees',
  'delete.employees',
] as const;

export const PERMISSIONS_ATTENDANCES_CONST = [
  // Attendance Resource
  'read.attendances',
] as const;

export const PERMISSIONS_VACATIONS_CONST = [
  // Vacation Resource
  'create.vacations',
  'read.vacations',
  'update.vacations',
  'delete.vacations',
] as const;

export const PERMISSIONS_IQAMA_CONST = [
  // Iqama Renewal Receipt
  'read.iqamaRenewalReceipts',
  'update.iqamaRenewalReceipts',
] as const;

export const PERMISSIONS_TASHERA_CONST = [
  // Tashera Payments
  'read.tasheraPayments',
  'update.tasheraPayments',
] as const;

export const PERMISSIONS_OTHER_FILES_CONST = [
  // Other Files
  'read.otherFiles',
  'update.otherFiles',
] as const;

export const PERMISSIONS_PASSPORT_CONST = [
  // Passport Request
  'read.passportRequests',
  'update.passportRequests',
  'delete.passportRequests',
] as const;

export const PERMISSIONS_UNIFORM_CONST = [
  // Uniform Request
  'create.uniformRequests',
  'read.uniformRequests',
  'update.uniformRequests',
  'delete.uniformRequests',
] as const;

export const PERMISSIONS_MEDICAL_PAPER_CONST = [
  // Medical Paper Rquest
  'create.medicalPaperRequests',
  'read.medicalPaperRequests',
  'update.medicalPaperRequests',
  'delete.medicalPaperRequests',
] as const;

export const PERMISSIONS_UMRAH_CONST = [
  // Umrah Request
  'create.umrahRequests',
  'read.umrahRequests',
  'update.umrahRequests',
  'delete.umrahRequests',
] as const;

export const PERMISSIONS_USERS_CONST = [
  // Manage Users
  'create.users',
  'read.users',
  'update.users',
  'delete.users',
] as const;

export const PERMISSIONS_ARTICLES_CONST = [
  // Manage Articles
  'create.articles',
  'read.articles',
  'update.articles',
  'delete.articles',
] as const;

export const PERMISSIONS_SALARY_DEDUCTIONS_CONST = [
  // Manage Deduction Salary
  'create.deductionSalary',
  'read.deductionSalary',
  'update.deductionSalary',
  'delete.deductionSalary',
] as const;

export const PERMISSIONS_EMPLOYEES= [...PERMISSIONS_EMPLOYEES_CONST];
export const PERMISSIONS_ATTENDANCES = [...PERMISSIONS_ATTENDANCES_CONST];
export const PERMISSIONS_VACATIONS = [...PERMISSIONS_VACATIONS_CONST];
export const PERMISSIONS_IQAMA = [...PERMISSIONS_IQAMA_CONST];
export const PERMISSIONS_TASHERA = [...PERMISSIONS_TASHERA_CONST];
export const PERMISSIONS_OTHER_FILES = [...PERMISSIONS_OTHER_FILES_CONST];
export const PERMISSIONS_PASSPORT = [...PERMISSIONS_PASSPORT_CONST];
export const PERMISSIONS_UNIFORM = [...PERMISSIONS_UNIFORM_CONST];
export const PERMISSIONS_MEDICAL_PAPER = [...PERMISSIONS_MEDICAL_PAPER_CONST];
export const PERMISSIONS_UMRAH = [...PERMISSIONS_UMRAH_CONST];
export const PERMISSIONS_USERS = [...PERMISSIONS_USERS_CONST];
export const PERMISSIONS_ARTICLES = [...PERMISSIONS_ARTICLES_CONST];
export const PERMISSIONS_SALARY_DEDUCTIONS = [...PERMISSIONS_SALARY_DEDUCTIONS_CONST];
export const PERMISSIONS = [
  ...PERMISSIONS_EMPLOYEES,
  ...PERMISSIONS_ATTENDANCES,
  ...PERMISSIONS_VACATIONS,
  ...PERMISSIONS_IQAMA,
  ...PERMISSIONS_TASHERA,
  ...PERMISSIONS_OTHER_FILES,
  ...PERMISSIONS_PASSPORT,
  ...PERMISSIONS_UNIFORM,
  ...PERMISSIONS_MEDICAL_PAPER,
  ...PERMISSIONS_UMRAH,
  ...PERMISSIONS_USERS,
  ...PERMISSIONS_ARTICLES,
  ...PERMISSIONS_SALARY_DEDUCTIONS
];

export const getEditorPermissions = (permissions: Permission[]) => {
  return permissions.filter(p => !p.startsWith('read.'));
};

export const getViewerPermissions = (permissions: Permission[]) => {
  return permissions.filter(p => p.startsWith('read.'));
};

export const hasPermission = (auth: {[k: string]: any}, roles?: Role[], permissions?: Permission[]) => {
  const rolesPermissions: Permission[] = roles ? roles.map(r => ROLES_PERMISSIONS_MAPPING.hasOwnProperty(r) ? ROLES_PERMISSIONS_MAPPING[r] : []).flat() : [];
  const allowedPermissions: Permission[] = permissions ? permissions : [];

  const allAllowedPermissions: Permission[] = [...rolesPermissions, ...allowedPermissions];  
  if (auth.URB.roles) {
    // Get the permissions for that role
    const userRoles: string[] = auth.URB.roles;
    const hasUserRolePermission = userRoles.some(r => {
      if (ROLES_PERMISSIONS_MAPPING.hasOwnProperty(r)) {
        return allAllowedPermissions.some(p => ROLES_PERMISSIONS_MAPPING[r as Role].includes(p));
      }

      return false;
    });

    if (hasUserRolePermission) {
      return true;
    }
  }

  if  (auth.URB.permissions) {
    const userPermissions: string[] = auth.URB.permissions;
    if (allAllowedPermissions.some(p => userPermissions.includes(p))) {
      return true;
    }
  }

  return false;
}

type Permission = typeof PERMISSIONS[number];

type PermissionDescription = {
  [key in Permission]: {
    name: string;
    description: string;
  };
};
export const PERMISSIONS_DESCRIPTIONS: PermissionDescription = {
  'create.employees': {
    name: 'Create Employees',
    description: '',
  },
  'read.employees': {
    name: 'View Employees',
    description: '',
  },
  'update.employees': {
    name: 'Update Employees',
    description: '',
  },
  'delete.employees': {
    name: 'Delete Employees',
    description: '',
  },
  
  'read.attendances': {
    name: 'View Attendances',
    description: '',
  },

  'create.vacations': {
    name: 'Create Vacation Requests',
    description: '',
  },
  'read.vacations': {
    name: 'View Vacation Requests',
    description: '',
  },
  'update.vacations': {
    name: 'Update Vacation Requests',
    description: '',
  },
  'delete.vacations': {
    name: 'Delete Vacation Requests',
    description: '',
  },
  
  'read.iqamaRenewalReceipts': {
    name: 'View Iqama Renewal Receipts',
    description: '',
  },
  'update.iqamaRenewalReceipts': {
    name: 'Update Iqama Renewal Receipts',
    description: '',
  },
  
  'read.tasheraPayments': {
    name: 'View Tashera Payments',
    description: '',
  },
  'update.tasheraPayments': {
    name: 'Update Tashera Payments',
    description: '',
  },
  
  'read.otherFiles': {
    name: 'View Other Files',
    description: '',
  },
  'update.otherFiles': {
    name: 'Update Other Files',
    description: '',
  },
  
  'read.passportRequests': {
    name: 'View Passport Requests',
    description: '',
  },
  'update.passportRequests': {
    name: 'Update Passport Requests',
    description: '',
  },
  'delete.passportRequests': {
    name: 'Delete Passport Requests',
    description: '',
  },
  
  'create.uniformRequests': {
    name: 'Create Uniform Requests',
    description: '',
  },
  'read.uniformRequests': {
    name: 'View Uniform Requests',
    description: '',
  },
  'update.uniformRequests': {
    name: 'Update Uniform Requests',
    description: '',
  },
  'delete.uniformRequests': {
    name: 'Delete Uniform Requests',
    description: '',
  },
  
  'create.medicalPaperRequests': {
    name: 'Create Medical Paper Requests',
    description: '',
  },
  'read.medicalPaperRequests': {
    name: 'View Medical Paper Requests',
    description: '',
  },
  'update.medicalPaperRequests': {
    name: 'Update Medical Paper Requests',
    description: '',
  },
  'delete.medicalPaperRequests': {
    name: 'Delete Medical Paper Requests',
    description: '',
  },
  
  'create.umrahRequests': {
    name: 'Create Umrah Paper Requests',
    description: '',
  },
  'read.umrahRequests': {
    name: 'View Umrah Paper Requests',
    description: '',
  },
  'update.umrahRequests': {
    name: 'Update Umrah Paper Requests',
    description: '',
  },
  'delete.umrahRequests': {
    name: 'Delete Umrah Paper Requests',
    description: '',
  },
  
  'create.users': {
    name: 'Create Admin App User',
    description: '',
  },
  'read.users': {
    name: 'View Admin App Users',
    description: '',
  },
  'update.users': {
    name: 'Update Admin App Users',
    description: '',
  },
  'delete.users': {
    name: 'Delete Admin App Users',
    description: '',
  },

  // ARTICLES
  'create.articles': {
    name: 'Create Articles',
    description: '',
  },
  'read.articles': {
    name: 'View Articles',
    description: '',
  },
  'update.articles': {
    name: 'Update/Edit Articles',
    description: '',
  },
  'delete.articles': {
    name: 'Delete Articles',
    description: '',
  },

  // SALARY DEDUCTION
  'create.deductionSalary': {
    name: 'Create Salary Deduction',
    description: '',
  },
  'read.deductionSalary': {
    name: 'View Salary Deduction',
    description: '',
  },
  'update.deductionSalary': {
    name: 'Update/Edit Salary Deduction',
    description: '',
  },
  'delete.deductionSalary': {
    name: 'Delete Salary Deduction',
    description: '',
  },
};

export default Permission;
